import React, { useEffect } from "react"
import { Container } from "@carrotfertility/carotene"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { CenteredLoadingIndicator } from "../../../views/molecules/Molecules"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"
import { waitForMinimumDelay } from "../../../../utils/WaitForMinimumDelay"
import { useRoutingInfo } from "../../context/RoutingInfoContext"
import { Steps } from "../journey/step-library"

const ViewName = Steps.PROCESS_ITS_A_MATCH

export default function ProcessItsAMatchStep(): JSX.Element {
  const { setNextStep } = useStateMachine(ViewName, null)
  const { setShowBackButton, setShowProgressTracker } = useJourneyFlow()
  const { setMemberScheduledInitialCarrotPlanExpertChat } = useRoutingInfo()

  useEffect(() => {
    setShowBackButton(false)
    setShowProgressTracker(false)
    waitForMinimumDelay(setMemberScheduledInitialCarrotPlanExpertChat(), 1000).then(() => setNextStep(ViewName, ""))
  }, [])

  return (
    <>
      <Container padding="large" stack="giant">
        <CenteredLoadingIndicator />
      </Container>
    </>
  )
}
